import { useState, useEffect } from 'react';
import { baseURL, tenantId } from '../../config/api';
import useWebData from '../../hooks/useWebData';
import { getVehicleClasses } from '../../services/vehicleClass';
import usePleaseWait from '../../hooks/usePleaseWait';
import { Helmet } from 'react-helmet-async';

const Fleet = () => {
  const { setPleasWaitPopup }: any = usePleaseWait();
  const { webData }: any = useWebData();
  const [availableVehicle, setAvailableVehicle] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [currentVehicle, setCurrentVehicle] = useState<any>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);

  useEffect(() => {
    setPleasWaitPopup(true);
    if (webData?.dataFetchingBranchId) {
      getVehicleClasses(webData?.dataFetchingBranchId, tenantId)
        .then(data => {
          setAvailableVehicle(data)
          setPleasWaitPopup(false);
        })
        .catch(error => {
          setAvailableVehicle([]);
          setPleasWaitPopup(false);
          console.error(error);
        })
    } else {
      setAvailableVehicle([]);
      setPleasWaitPopup(false);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webData])

  const openModal = (vehicle: any, _: number) => {
    setCurrentVehicle(vehicle);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentVehicle(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    if (!currentVehicle) return;
    setCurrentImageIndex((prev) =>
      prev === currentVehicle?.fileNameDataDto?.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    if (!currentVehicle) return;
    setCurrentImageIndex((prev) =>
      prev === 0 ? currentVehicle?.fileNameDataDto?.length - 1 : prev - 1
    );
  };

  return (
    <>
      <Helmet>
        <title>Clean & Reliable Vehicles Available for Rent | Our Fleet</title>
        <meta
          name="description"
          content="Explore our fleet of clean, well-maintained vehicles available for rent. Choose from multiple vehicle options perfect for trips, events, and travel."
        />
      </Helmet>
      <div className="w-full flex flex-col p-6 md:p-10 lg:p-16 xl:px-24 2xl:px-32 mt-[140px]">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Rental Vehicle Fleet
          </h1>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
          {availableVehicle?.map((item, index) => (
            <div
              key={index}
              className="bg-white border rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden flex flex-col cursor-pointer"
              onClick={() => openModal(item, index)}
            >
              {/* Small carousel preview */}
              <div className="w-full h-48 relative">
                <img
                  src={
                    item?.fileNameDataDto?.[0]?.fileName?.startsWith("data:image")
                      ? item.fileNameDataDto[0]?.fileName
                      : `${baseURL}vehicleClassFile/Get?name=${item.fileNameDataDto[0]?.fileName}`
                  }
                  alt={`${item?.label} rental vehicle` || "Vehicle"}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Info */}
              <div className="p-4 flex flex-col gap-2 flex-1">
                <span className="text-lg font-semibold">{item?.label}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {isModalOpen && currentVehicle && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
            <div className="relative max-w-3xl w-full mx-4 bg-white rounded-md p-10">
              {/* Image */}
              <img
                src={
                  currentVehicle.fileNameDataDto[currentImageIndex]?.fileName.startsWith("data:image")
                    ? currentVehicle.fileNameDataDto[currentImageIndex]?.fileName
                    : `${baseURL}vehicleClassFile/Get?name=${currentVehicle.fileNameDataDto[currentImageIndex]?.fileName}`
                }
                alt="Vehicle"
                className="w-full md:w-[768px] h-[60dvh] md:h-[75dvh] object-contain rounded mt-4"
              />

              {/* Prev/Next Buttons */}
              <button
                onClick={prevImage}
                className={`absolute top-1/2 left-4 transform -translate-y-1/2 rounded-full p-2 ${currentVehicle?.fileNameDataDto?.length <= 1 ? "opacity-20 cursor-default" : "cursor-pointer"}`}
              >
                ◀
              </button>
              <button
                onClick={nextImage}
                className={`absolute top-1/2 right-4 transform -translate-y-1/2 rounded-full p-2 ${currentVehicle?.fileNameDataDto?.length <= 1 ? "opacity-20 cursor-default" : "cursor-pointer"}`}
              >
                ▶
              </button>

              {/* Close Button */}
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 text-black text-2xl"
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </div>
    </>

  );
}

export default Fleet